import React from "react";

const stats = [
  { n: "18", l: "Years" },
  { n: "2008", l: "Established" },
  { n: "100%", l: "Non-profit" },
];

function Stats() {
  return (
    <section className="hm-stats">
      <div className="hm-wrap">
        {stats.map((s) => (
          <div className="hm-stat" key={s.l}>
            <div className="hm-stat-n">{s.n}</div>
            <div className="hm-stat-l">{s.l}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Stats;
